import { useEffect, useRef } from "react";

// Este hook inserta un event listener a un elemento del DOM en específico (por defecto es window),
// que ejecuta una función cuando la acción se realiza.

// PARAMETROS:
// type: el tipo de evento que estará 'escuchando'
// callback: la función que se ejecuta al detectarse el evento
// domElement: el elemento del dom al que se inserta el listener, por defecto el objeto 'window'
const useEventListener = (type, callback, domElement = window) => {
  const callbackRef = useRef();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const listener = (e) => callbackRef.current(e);

    domElement.addEventListener(type, listener);

    return () => {
      domElement.removeEventListener(type, listener);
    };
  }, [type, domElement]);
};

export default useEventListener;
